import { css, cx } from '@eti/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const cardStyles = ({
  isActive,
  hasBorder,
  isInteractive
}) => css`
  position: relative;

  &:hover {
    cursor: ${hasBorder && isInteractive && 'pointer'};
  }

  &::after {
    border: ${hasBorder && (isActive ? '3px solid #8bb78b' : '1px solid #d9d9d9')};
    border-radius: 3px;
    content: '';
    inset: 0;
    pointer-events: none;
    position: absolute;
    z-index: 5;
  }

  &:hover::after {
    border-bottom-width: ${hasBorder && isInteractive && !isActive && '5px'};
    border-top-width: ${hasBorder && isInteractive && !isActive && '5px'};
  }
`;
const handleKeyDown = onClick => e => {
  if (onClick && e.keyCode === 32) {
    onClick(e);
  }
};
const ProductCard = ({
  isActive,
  hasBorder = true,
  children,
  className,
  isInteractive,
  onClick,
  isSuccess
}) => /*#__PURE__*/_jsx("div", {
  className: cx('ProductCard', cardStyles({
    isActive,
    hasBorder,
    isInteractive
  }), className, {
    'ProductCard--active': isActive,
    'ProductCard--success': isSuccess
  }),
  onClick: onClick,
  onKeyDown: handleKeyDown(onClick),
  role: "presentation",
  children: children
});
export default ProductCard;
//# sourceMappingURL=ProductCard.js.map